import {
  HTTP_INSERTBUDGET_FETCHING,
  HTTP_INSERTBUDGET_SUCCESS,
  HTTP_INSERTBUDGET_FAILED,
  server,
  OK,
  YES,
} from "././../../Constants";
import { httpClient } from "././../../utils/HttpClient";
import { async } from "q";
import Axios from "axios";
import { getBudgetsById } from "../actions/budgets.action";
import { getBudgetsDetail } from "../actions/budgetsdetail.action";
//insert Budgets
export const setStateinsertBudgetsToFetching = () => ({
  type: HTTP_INSERTBUDGET_FETCHING,
});

export const setStateinsertBudgetsToSuccess = (payload) => ({
  type: HTTP_INSERTBUDGET_SUCCESS,
  payload,
});

export const setStateinsertBudgetsToFailed = (payload) => ({
  type: HTTP_INSERTBUDGET_FAILED,
});

export const insertBudgetsById = (item) => {
  return (dispatch) => {
    dispatch(setStateinsertBudgetsToFetching());

    // const result = await httpClient.put(
    return httpClient
      .post(`${server.INSERTBUDGETS_URL}`, item)
      .then(() => {
        dispatch(
          getBudgetsById(
            item.COUNTRYID,
            item.COMPANYID,
            item.BRANDID,
            item.DEPARTID,
            item.YEARID,
            item.SECID
          )
        );
        dispatch(
          getBudgetsDetail(
            item.COUNTRYID,
            item.COMPANYID,
            item.BRANDID,
            item.DEPARTID,
            item.YEARID,
            item.SECID
          )
        );
        dispatch(setStateinsertBudgetsToSuccess("success"));
      })
      .catch((err) => {
        dispatch(setStateinsertBudgetsToFailed());
      });

    // dispatch(setStateinsertBudgetsToFailed());
  };
};
